import { Trophy, ExternalLink } from 'lucide-react';
import { useDlResults } from '@/hooks/useDlResults';
import { safeHref } from '@/lib/safeUrl';
import DownloadButton from '@/components/ui/download-button';

const OPPSection = () => {
  const { enabled, card_title, card_text, url, file_url } = useDlResults();
  if (!enabled) return null;
  return (
    <section aria-label="Wyniki naboru Działaj Lokalnie" className="py-6 bg-muted/50">
      <div className="container">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 bg-background border-2 border-primary rounded-panel p-5 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary text-primary-foreground shrink-0">
              <Trophy className="w-5 h-5" aria-hidden="true" />
            </div>
            <div>
              <p className="font-heading font-bold text-sm">{card_title}</p>
              <p className="text-xs text-muted-foreground">{card_text}</p>
            </div>
          </div>
          <div className="flex flex-wrap gap-2">
            <a
              href={safeHref(url, '#')}
              target="_blank"
              rel="noopener noreferrer external"
              aria-label="Zobacz wyniki naboru Działaj Lokalnie 2026 (otwiera się w nowej karcie)"
              className="inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors text-sm px-4 py-2 bg-primary text-primary-foreground hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background"
            >
              <span>Zobacz wyniki</span>
              <ExternalLink className="w-4 h-4" aria-hidden="true" />
              <span className="sr-only"> (nowa karta)</span>
            </a>
            <DownloadButton
              href={file_url}
              variant="outline"
              label="Pobierz listę rankingową"
              fileTitle="Lista rankingowa Działaj Lokalnie 2026"
              fileType="JPG"
              fileName="lista-rankingowa-dl-2026.jpg"
              mimeType="image/jpeg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OPPSection;

